export default __webpack_public_path__ + "static/How AI Is Transforming Language Learning-0504153ecb86ce34558b6ce480789c1e.jpg";